/** CEP: 8 dígitos. Não há dígito verificador — só formato. */

const COMPRIMENTO_CEP = 8;

const MASCARA_CEP = /^(\d{5})(\d{3})$/;

/** Remove tudo que não for dígito. */
export function normalizarCep(valor: string): string {
  return valor.replace(/\D/g, '');
}

/**
 * Valida um CEP: exatamente 8 dígitos.
 *
 * `00000000` é rejeitado por ser um preenchimento sabidamente inválido.
 */
export function validarCep(valor: string): boolean {
  const cep = normalizarCep(valor);
  if (cep.length !== COMPRIMENTO_CEP) return false;
  if (cep === '00000000') return false;
  return true;
}

/**
 * Formata como `00000-000`.
 *
 * Se o valor normalizado não tiver 8 dígitos, devolve o valor normalizado sem máscara.
 */
export function formatarCep(valor: string): string {
  const cep = normalizarCep(valor);
  if (cep.length !== COMPRIMENTO_CEP) return cep;
  return cep.replace(MASCARA_CEP, '$1-$2');
}
